import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { jsx as t, Fragment as e } from "react/jsx-runtime";
import n from "styled-components";
import { calculateRem as o } from "@vds-core/utilities";
import { LayoutTokens as r } from "@vds-tokens/layout";
import "../Controls/PaginationStepControl.js";
import i from "../Controls/PaginationListItem.js";
import a from "../Controls/PaginationLink.js";
var s = n(i).withConfig({
    displayName: "PaginationNumbersContainer",
    componentId: "VDS__sc-75hqso-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  height: ", ";\n  justify-content: center;\n  min-width: ", ";\n\n  ", "\n"])), o("16px"), o("20px"), function (_ref) {
    var t = _ref.index,
      e = _ref.$startRange;
    return t !== e && "margin-left: ".concat(o(r.space["1X"].value), ";");
  }),
  l = n.span.withConfig({
    displayName: "StyledSpan",
    componentId: "VDS__sc-75hqso-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  svg {\n    margin-top: -1px;\n  }\n"]))),
  c = function c(n) {
    var o = n.total,
      r = n.selectedPage,
      i = n.baseUrl,
      c = n.selectPage,
      m = n.surface,
      _ref2 = function (t, e) {
        var n = t < 98 ? 3 : 2;
        var o = Math.min(t - 1, e - n);
        return 1 === t && (o = 1), {
          startRange: o,
          endRange: o + n
        };
      }(r, o),
      p = _ref2.startRange,
      f = _ref2.endRange,
      g = function g(t) {
        null == c || c(t);
      };
    return t(e, {
      children: Array.from({
        length: o + 1
      }, function (t, e) {
        return e;
      }).map(function (e, n) {
        return n >= p && n <= f && 0 !== n && t(s, {
          $startRange: p,
          index: n,
          children: t(a, {
            pageNumber: n,
            selectedPage: r,
            baseUrl: i,
            onClick: g,
            surface: m,
            total: o,
            children: t(l, {
              children: n
            })
          })
        }, n);
      })
    });
  };
c.defaultProps = {
  total: 20,
  selectedPage: 10,
  surface: "light"
};
export { c as default };